import { FC, memo, useCallback } from 'react'

import { Button, Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Col, Grid } from 'components/grid'
import { Polygon } from 'components/polygon'
import { theme } from 'styles/theme'
import { pushDataLayer } from 'utils/push-data-layer'

import { SUPPLIER_CODE_URL } from '../documents'

import * as S from './styles'

const IMAGES_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/integrity-program`

/* Label preservado do que já estava em produção: mudá-lo quebraria os
   relatórios existentes. */
const dataLayer = {
  category: 'Clique',
  action: 'Botões',
  label:
    'Relacionamento com Fornecedores e Cashmembers - Programa de Integridade - Código de Relacionamento Fornecedor'
}

const Relationship: FC = memo(() => {
  /* Mantém a âncora criada em memória em vez de window.open, como já era
     feito aqui: preserva o target _blank e o comportamento coberto por teste. */
  const handleClick = useCallback(() => {
    pushDataLayer(dataLayer)

    const anchor = document.createElement('a')
    anchor.href = SUPPLIER_CODE_URL
    anchor.target = '_blank'
    anchor.rel = 'noopener noreferrer'
    anchor.click()
  }, [])

  return (
    <S.Section aria-labelledby="integrity-relationship-title">
      <S.LineWrapper aria-hidden>
        <NextImage src={`${IMAGES_PATH}/relacionamento-line.svg`} alt="" width={650} height={201} />
      </S.LineWrapper>

      <S.PolygonWrapper aria-hidden>
        <Polygon type="TriangleRound" width={44} height={56} draw="fill" color={theme.colors['cashme-magenta']} />
      </S.PolygonWrapper>

      <Grid col={{ phone: 1, tablet: 12 }}>
        <Col col={{ tablet: 10, desktop: 5 }} start={{ tablet: 2, desktop: 2 }}>
          <S.Infos>
            <Text
              id="integrity-relationship-title"
              as="h2"
              size="heading2"
              weight="medium"
              color="var(--colors-cyan-background-pressed)"
            >
              Relacionamento{' '}
              <Text as="span" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                com Fornecedores e CashMembers
              </Text>
            </Text>

            <S.Paragraphs>
              <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
                Transparência e respeito nas relações são fundamentais para a construção de um ambiente de confiança
                mútua e de responsabilidade em todos os níveis.
              </Text>
              <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
                Por isso, disponibilizamos a seguir as orientações que firmam o relacionamento com nossos parceiros.
              </Text>
            </S.Paragraphs>

            <Button size="lg" onClick={handleClick}>
              Código de Relacionamento Fornecedor
            </Button>
          </S.Infos>
        </Col>
      </Grid>

      <S.ImageWrapper>
        <NextImage
          src={`${IMAGES_PATH}/relacionamento-cashmembers.webp`}
          alt="Três pessoas do time da CashMe conversando com canecas na mão, ao redor do C da marca"
          width={2266}
          height={1511}
          sizes="(min-width: 1240px) 60vw, 100vw"
          quality={82}
        />
      </S.ImageWrapper>
    </S.Section>
  )
})

Relationship.displayName = 'Relationship'

export default Relationship
